import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { patch } from 'helpers/requests';
import PageContainer from 'components/PageContainer';
import * as actions from 'redux-store/actions';
import { GET_CLIENT_LIST, GET_CLIENT_ROLES } from '../../redux-store/constants/action-types';
import { API, BASE_URL, SEARCH_DELAY_MS } from '../../CONST';
import ClientListTable from './ClientListTable';
import isUserHasProfile from '../../helpers/profileValidator';
import sso from '../../helpers/auth';
import { CLIENT_WRITE } from '../../helpers/profilePermission';

const api = API.clients;

class ClientList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      exporting: false,
      lastFiltered: [],
    };
    this.filtering = false;

    this.onFilteredChange = this.onFilteredChange.bind(this);
    this.fetchStrategy = this.fetchStrategy.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchRoles = this.fetchRoles.bind(this);
    this.handleToggleActive = this.handleToggleActive.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, SEARCH_DELAY_MS);
  }

  componentDidMount() {
    this.fetchRoles();
  }

  onFilteredChange() {
    this.filtering = true;
  }

  fetchStrategy(tableState) {
    if (this.filtering) {
      return this.fetchDataWithDebounce(tableState);
    }
    return this.fetchData(tableState);
  }

  buildFilterQueryString(filtered) {
    let query = '';
    if (filtered && filtered.length) {
      filtered.forEach((node) => {
        let validFilter = false;
        let filterValue = node.value;

        if (typeof node.value === 'number' && node.value > 0) {
          filterValue = node.value;
          validFilter = true;
        } else if (typeof node.value === 'string' && node.value.length > 2) {
          filterValue = node.value;
          validFilter = true;
        }

        if (validFilter) {
          query = `${query}${node.id}=${filterValue}&`;
        }
      });
    }
    return query;
  }

  fetchData(state) {
    const { getData } = this.props;

    this.filtering = false;
    this.setState({
      loading: true,
      lastFiltered: state.filtered,
    });

    let filters = `${BASE_URL}${api}?is_main=0&page=${state.page + 1}&${this.buildFilterQueryString(state.filtered)}`;

    getData({
      url: filters,
      name: 'clients',
      type: GET_CLIENT_LIST,
    });
    this.setState({ loading: false });
  }

  async handleExport() {
    try {
      this.setState({ exporting: true });

      const query = `is_main=0&${this.buildFilterQueryString(this.state.lastFiltered)}`;
      const response = await fetch(`${BASE_URL}${api}export/?${query}`, {
        headers: { Authorization: `Bearer ${sso.get().accessToken}` },
      });
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'clientes.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting clients:', error);
    } finally {
      this.setState({ exporting: false });
    }
  }

  fetchRoles() {
    const { getData } = this.props;
    this.setState({
      loading: true,
    });

    getData({
      url: `${BASE_URL}${API.roles}`,
      name: 'roles',
      type: GET_CLIENT_ROLES,
    });

    this.setState({ loading: false });
  }

  async handleToggleActive(organization) {
    try {
      const newStatus = !organization.is_active;
      await patch(
        `${BASE_URL}${api}${organization.id}/`,
        { is_active: newStatus }
      );
      
      const currentPage = this.props.clients.listData.currentPage || 0;
      this.fetchData({ 
        page: currentPage, 
        filtered: [] 
      });

    } catch (error) {
      console.error('Error toggling organization status:', error);
    }
  }

  render() {
    const { loading, exporting } = this.state;
    const { clients } = this.props;
    return (
      <PageContainer breadcrumbs={[{ name: 'ORSAN' }, { name: 'LISTA DE CLIENTES' }]}>
        <Col md={{ offset: 9 }}>
          <div className="d-flex justify-content-end align-items-center mb-3">
            <button
              type="button"
              className="btn btn-outline-secondary mr-2"
              disabled={exporting}
              onClick={this.handleExport}
            >
              <FontAwesomeIcon icon={faFileExcel} className="mr-1" />
              {exporting ? 'Exportando...' : 'Exportar Excel'}
            </button>

            {isUserHasProfile(CLIENT_WRITE) && (
              <Link
                to="/clients/create"
                className="btn btn-secondary"
                style={{
                  backgroundColor: '#0055B8',
                  borderColor: '#0055B8',
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-1" />
                Crear cliente
              </Link>
            )}
          </div>
        </Col>

        <ClientListTable
          count={clients.listData.count}
          data={clients.listData.data}
          loading={loading}
          pages={clients.listData.pages}
          onFetchData={this.fetchStrategy}
          onFilteredChange={this.onFilteredChange}
          onToggleActive={this.handleToggleActive}
          roles={clients.roles}
        />
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({ clients: state.clients });

function mapDispatchToProps(dispatch) {
  return {
    getData: (clients) => dispatch(actions.getData(clients)),
  };
}

const ClientListView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientList);

ClientList.propTypes = {
  clients: PropTypes.shape({
    count: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object),
    next: PropTypes.string,
    pages: PropTypes.number,
    previous: PropTypes.string,
    listData: PropTypes.shape({
      count: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
      pages: PropTypes.number,
      currentPage: PropTypes.number,
    }),
  }).isRequired,
  getData: PropTypes.func.isRequired,
};
export default ClientListView;